import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import ClickableText from '../ClickableText/ClickableText';
import './PopUp.css'

Modal.setAppElement('#root'); // Required for accessibility

const PopUp = ({ isOpen, onClose, selection, popUpType }) => {

    const [projectData, setProjectData] = useState(null);

    const fetchProjectPopUp = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_DASHBOARD_URL}get_project_popup?project_title=${encodeURIComponent(selection)}`);
            
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            let data = await response.json();

            setProjectData(data.project_details);

        } catch (error) {
            console.error('Error fetching project details:', error);
        }
    };

    const fetchTagPopUp = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_DASHBOARD_URL}/get_associated_projects?tag_to_search=${encodeURIComponent(selection)}`);
            
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            let data = await response.text();

            setProjectData(data.titles);

        } catch (error) {
            console.error('Error fetching project details:', error);
        }
    };

    const renderComponent = () => {
        if (projectData && popUpType == 'project') {
            return <>
                <div className='container'>
                    <h1>{projectData?.title || 'N/A'}</h1>
                    &nbsp;
                    <div className='textContainer'>
                        <div className='labels'>
                            <p>Category</p>
                            <p>Details</p>
                            <p>Likes</p>
                            <p>Phase</p>
                            <p>Recruiting</p>
                        </div>
                        <div className='details'>
                            <p>{projectData?.category || 'N/A'}</p>
                            <p>{projectData?.details || 'N/A'}</p>
                            <p>{projectData?.likes || 'N/A'}</p>
                            <p>{projectData?.phase || 'N/A'}</p>
                            <p>{projectData?.recruiting ? 'Yes' : 'No'}</p>
                        </div>
                       
                    </div>
                </div>
            </>
        }

        if (projectData && popUpType === 'tag') {
            return (
                <>
                <h1>Projects</h1>
                <div className='labels'>
                    {projectData && projectData.length > 0 ? (
                        projectData.map((project, index) => (
                            <ClickableText key={index} clickableProject={project} />
                        ))
                    
                ) : (
                    <p>No projects available</p>
                )}
                </div>
                </>
            );
        }
    }
    useEffect(() => {
        if (isOpen && selection) {
            if (popUpType == 'project') {
                fetchProjectPopUp();
            }

            if (popUpType == 'tag') {
                fetchTagPopUp();
            }
        }
    }, [isOpen]); 

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onClose}
            style={{
                overlay: { backgroundColor: 'rgba(0, 0, 0, 0.7)' },
                content: {
                    top: '50%',
                    left: '50%',
                    right: 'auto',
                    bottom: 'auto',
                    transform: 'translate(-50%, -50%)',
                    width: '800px',
                    height: '400px',
                    padding: '20px',
                    borderRadius: '10px',
                    backgroundColor: 'rgb(211, 211, 211)',
                },
            }}
        >
            {renderComponent()}
            <button className='popupcloseBtn' onClick={onClose}>Close</button>
        </Modal>
    );
};

export default PopUp;
